// The four names people know. Anything else, including mobile variants, reads as "your browser".
export function browserName(userAgent = navigator.userAgent) {
  if (/Edg(e|A|iOS)?\//.test(userAgent)) return 'Edge';
  if (/Chrome\/|CriOS\//.test(userAgent)) return 'Chrome';
  if (/Firefox\/|FxiOS\//.test(userAgent)) return 'Firefox';
  if (/Safari\//.test(userAgent)) return 'Safari';
  return 'your browser';
}

export default function blockedAutoplayMessage({ title = null, where = null, again = false } = {}) {
  if (again) {
    return `We opened a fresh player window, but ${browserName()} still wants you to press play in it`;
  }
  let what = title || 'playback';
  let place = where ? ` in ${where}` : '';
  return `We tried to start ${what}${place}, but ${browserName()} wants you to press play yourself`;
}

// Only Firefox and Safari have a switch a listener can flip. Chrome and Edge decide from listening history.
export function allowAutoplayHint(userAgent = navigator.userAgent) {
  switch (browserName(userAgent)) {
    case 'Firefox':
      return 'To let this play on its own next time, click the permissions icon left of the address bar and set Autoplay to Allow Audio and Video.';
    case 'Safari':
      return 'To let this play on its own next time, open Safari › Settings for This Website and set Auto-Play to Allow All Auto-Play.';
    case 'Chrome':
    case 'Edge':
      return `${browserName(userAgent)} will stop asking once you have listened here a few times.`;
    default:
      return null;
  }
}
